import { tw } from '~/utils/tw-merge'
import { PageSection } from './page-section'

interface HeadingDescriptionActionSectionProps {
  heading?: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  maxWidthClassName?: string
}

export function HeadingDescriptionActionSection({
  heading,
  description,
  maxWidthClassName,
  action
}: HeadingDescriptionActionSectionProps) {
  return (
    <div>
      <PageSection className={tw(maxWidthClassName)}>
        <div className="flex flex-col gap-y-4 text-center items-center">
          <div>{typeof heading === 'string' ? <h1 className="typography-h1">{heading}</h1> : heading}</div>
          <div>
            {typeof description === 'string' ? <p className="max-w-(--breakpoint-sm)">{description}</p> : description}
          </div>
          {action ? <div>{action}</div> : null}
        </div>
      </PageSection>
    </div>
  )
}
